import { useLocaleStore } from '@/store/locale';
import type { Locale } from './platformTypes';

export const translations = {
	en: {
		chooseTitle: 'Choose your platform',
		chooseDescription: 'You have already connected to these LogAlto platforms.',
		forget: 'Forget',
		another: 'Use another platform',
		platformTitle: 'What is your LogAlto platform?',
		platformDescription: 'Enter your organization subdomain to continue.',
		continue: 'Continue',
		registerPrompt: 'Do not have a platform yet?',
		back: 'Back to my platforms',
		register: 'Sign up',
		subdomainLabel: 'Your platform subdomain',
		invalid: 'Please enter a valid platform subdomain.',
		unavailable: 'This platform could not be found. Check the subdomain and try again.',
		unknown: 'Something went wrong. Please try again.',
		invalidOAuthRequest: 'Invalid sign-in request. Return to the application and start signing in again.',
		connecting: 'Connecting to',
		loading: 'Loading',
	},
	fr: {
		chooseTitle: 'Choisissez votre plateforme',
		chooseDescription: 'Vous vous êtes déjà connecté à ces plateformes LogAlto.',
		forget: 'Oublier',
		another: 'Utiliser une autre plateforme',
		platformTitle: 'Quelle est votre plateforme LogAlto ?',
		platformDescription: 'Entrez le sous-domaine de votre organisation pour continuer.',
		continue: 'Continuer',
		registerPrompt: 'Vous n’avez pas encore de plateforme ?',
		back: 'Revenir à mes plateformes',
		register: 'S’inscrire',
		subdomainLabel: 'Sous-domaine de votre plateforme',
		invalid: 'Veuillez entrer un sous-domaine de plateforme valide.',
		unavailable: 'Cette plateforme est introuvable. Vérifiez le sous-domaine et réessayez.',
		unknown: 'Une erreur est survenue. Veuillez réessayer.',
		invalidOAuthRequest: 'Requête de connexion invalide. Retournez dans l’application et recommencez la connexion.',
		connecting: 'Connexion à',
		loading: 'Chargement',
	},
	es: {
		chooseTitle: 'Elige tu plataforma',
		chooseDescription: 'Ya te has conectado a estas plataformas LogAlto.',
		forget: 'Olvidar',
		another: 'Usar otra plataforma',
		platformTitle: '¿Cuál es tu plataforma LogAlto?',
		platformDescription: 'Introduce el subdominio de tu organización para continuar.',
		continue: 'Continuar',
		registerPrompt: '¿Aún no tienes una plataforma?',
		back: 'Volver a mis plataformas',
		register: 'Registrarse',
		subdomainLabel: 'Subdominio de tu plataforma',
		invalid: 'Introduce un subdominio de plataforma válido.',
		unavailable: 'No se encontró esta plataforma. Comprueba el subdominio e inténtalo de nuevo.',
		unknown: 'Se produjo un error. Inténtalo de nuevo.',
		invalidOAuthRequest:
			'Solicitud de inicio de sesión no válida. Vuelve a la aplicación e inicia sesión de nuevo.',
		connecting: 'Conectando a',
		loading: 'Cargando',
	},
} as const;

export type Translation = (typeof translations)[Locale];

export function getLocale(): Locale {
	const locale = window.location.pathname.split('/')[1];
	if (locale === 'en' || locale === 'fr' || locale === 'es') return locale;
	const savedLocale = useLocaleStore.getState().locale;
	if (savedLocale) return savedLocale;

	const browserLocale = window.navigator.language.toLowerCase().split('-')[0];
	return browserLocale === 'fr' || browserLocale === 'es' ? browserLocale : 'en';
}
